import SwissPostQuery from "../query/SwissPost.query";
import { fetchQuery } from 'Util/Request';

const state = (originalMember) => ({
    ...originalMember,
    validationState: null
});

const componentDidMount = (args, callback, instance) => {
    console.log(instance.props.address);
    const {
        firstname,
        lastname,
        country_id,
        street,
        city,
        postcode
    } = instance.props.address;
    if (country_id === 'CH') {
        instance.getAddressValidation({
            firstname,
            lastname,
            street,
            city,
            postcode
        });
    }
}

const getAddressValidationState = (code) => {
    switch(code) {
        case "CERTIFIED":
        case "DOMICILE_CERTIFIED":
            return "CERTIFIED";
        case "USABLE":
        case "FIXED":
            return "VALID";
        case "UNUSABLE":
        case "COMPROMISED":
            return "NOT VALID"
        case "ERROR":
        default:
            return "ERROR";
    }
}

const getAddressValidation = async (args, callback, instance) => {
    const [addressPayload] = args;
    const { validateShippingAddress: validateCode} = await fetchQuery(SwissPostQuery.getValidateShippingAddressQuery(addressPayload));
    const validationState = getAddressValidationState(validateCode);
    instance.setState({
        validationState
    });
}

const containerProps = (args, callback, instance) => {
    return {
        ...callback(),
        validationState: instance.state.validationState
    }
}

export default {
    'Component/MyAccountAddressTable/Container': {
        'member-property': {
            state
        },
        'member-function': {
            componentDidMount,
            getAddressValidation,
            containerProps
        }
    }
}